import { Loading } from '../loading';
import styles from './loader.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export var Loader = function Loader() {
  return /*#__PURE__*/_jsx(Loading, {
    className: styles.loader
  });
};